<template>
  <div :class="boxClasses" :style="boxStyle" 
    @mouseleave="$emit('mouseleave')"
    @mouseenter="$emit('mouseenter')"
    @click="$emit('click')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ALiquidGlassBox',
  props: {
    padding: {
      type: [String, Number],
      default: null
    },
    top: {
      type: [String, Number],
      default: null
    },
    left: {
      type: [String, Number],
      default: null
    },
    right: {
      type: [String, Number],
      default: null
    },
    bottom: {
      type: [String, Number],
      default: null
    },
    height: {
      type: [String, Number],
      default: null
    },
    width: {
      type: [String, Number],
      default: null
    },
    opacity: {
      type: [String, Number],
      default: null
    },
    class: {
      type: [String, Object, Array],
      default: null
    }
  },
  computed: {
    hasOverlay() {
      return this.isSet(this.top) || this.isSet(this.left) || this.isSet(this.right) || this.isSet(this.bottom)
    },
    boxClasses() {
      return {
        'liquid-glass-box': true,
        'liquid-glass-overlay': this.hasOverlay
      }
    },
    boxStyle() {
      const style = {}

      if (this.isSet(this.top)) style.top = this.toCssValue(this.top)
      if (this.isSet(this.left)) style.left = this.toCssValue(this.left)
      if (this.isSet(this.right)) style.right = this.toCssValue(this.right)
      if (this.isSet(this.bottom)) style.bottom = this.toCssValue(this.bottom)
      if (this.isSet(this.opacity)) style['--liquid-glass-opacity'] = this.opacity
      if (this.isSet(this.padding)) style.padding = this.toCssValue(this.padding)
      if (this.isSet(this.height)) style.height = this.toCssValue(this.height)
      if (this.isSet(this.width)) style.width = this.toCssValue(this.width)
      if (this.isSet(this.class)) style.class = this.class
console.log(style)
      return style
    }
  },
  methods: {
    isSet(value) {
      return value !== null && value !== undefined && value !== ''
    },
    toCssValue(value) {
      return typeof value === 'number' ? `${value}px` : value
    }
  }
}
</script>

<style scoped>
.liquid-glass-box {
  padding: 30px;
  border-radius: 15px;
  border: 2px solid rgba(225, 225, 225, 0.5) !important;
  background-color: rgba(255, 255, 255, var(--liquid-glass-opacity, 0.2)) !important;
  backdrop-filter: blur(6px) !important;
  -webkit-backdrop-filter: blur(6px) !important;
}

.theme--dark .liquid-glass-box {
  padding: 30px;
  border-radius: 15px;
  border: 2px solid rgba(20, 20, 20, 0.5) !important;
  background-color: rgba(30, 30, 30, var(--liquid-glass-opacity, 0.2)) !important;
  backdrop-filter: blur(6px) !important;
  -webkit-backdrop-filter: blur(6px) !important;
}

.liquid-glass-overlay {
  position: absolute;
  z-index: 5;
  display: flex;
  justify-content: center;
}
</style>
